module.exports = __webpack_public_path__ + "img/LOUISA COFFEE.ad67a373.svg";